import { isValidEmail } from '../../helpers/validator';

const schema = {
  email: {
    type: 'text',
    errorMessage: ['errors.email.required', 'errors.email.rules'],
    isValid: [(value) => value.length > 0, (value) => isValidEmail(value)],
  },
};

export default schema;
